import { Component, DestroyRef, OnInit } from '@angular/core';
import { BookingEditorService } from '../../../services/booking-editor/booking-editor.service';
import { UtilService } from '../../../services/util.service';
import { API, BookingDTO, CommercialFullDTO } from '../../../services/api/api';
import { BookingService } from '../../../services/booking.service';
import { SbLocalDateTime } from '../../../services/api/api-date-time';
import { DateTime } from 'luxon';
import { ErrorService } from '@ngx-seatback/utils';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-commercial-editor',
  templateUrl: './sb-commercial-editor.component.html',
  styleUrls: ['./sb-commercial-editor.component.scss'],
  standalone: false,
})
export class SbCommercialEditorComponent implements OnInit {
  formIsValid: boolean;
  commercialData: CommercialFullDTO;
  now: SbLocalDateTime;
  showShareOfVoice: boolean;
  loadingRequirements: boolean;

  constructor(
    public bookingEditor: BookingEditorService,
    public util: UtilService,
    private bookingService: BookingService,
    private api: API,
    private destroyRef: DestroyRef,
    private errorService: ErrorService
  ) {
    this.loadingRequirements = true;
  }

  saveForm() {
    if (this.formIsValid) {
      if (this.commercialData && this.commercialData.requirements?.length > 0) {
        const promises = this.commercialData.requirements.map(req => {
          if (req.bookings && this.commercialData?.planning && !this.commercialData?.overwrites) {
            return this.bookingService.editBookings(req.bookings, this.bookingEditor.planningId);
          }
        });
        if (promises.length > 0) {
          Promise.allSettled(promises).then(() => {
            this.bookingEditor.saveCommercialEdit().then();
          });
        } else {
          this.bookingEditor.saveCommercialEdit().then();
        }
      } else {
        this.bookingEditor.saveCommercialEdit().then();
      }
    }
  }

  setFormState(e: boolean) {
    this.formIsValid = e;
  }

  toggleEditor() {
    this.bookingEditor.saveCommercialEdit(true).then();
    if (this.bookingEditor.editorType === 'bigEditor' || !this.bookingEditor.editorType) {
      this.bookingEditor.editorType = 'smallEditor';
    } else {
      this.bookingEditor.editorType = 'bigEditor';
    }
    this.bookingEditor.showEditor(true);
  }

  ngOnInit(): void {
    this.commercialData = this.bookingEditor.editingRecord.get('commercial');
    if (this.bookingEditor.editorType == 'bigEditor') {
      this.refreshFromServer();
    } else {
      this.loadingRequirements = false;
    }
    this.now = new SbLocalDateTime();
    this.now.value = DateTime.local().minus({ day: 1 });
    if (this.commercialData && this.now < this.commercialData.from) {
      this.showShareOfVoice = true;
    }
  }

  updateBookings(bookings: BookingDTO[]) {
    this.commercialData.requirements[0].bookings = bookings;
  }

  refreshFromServer() {
    this.loadingRequirements = true;
    if (this.bookingEditor.planningId != null) {
      this.api
        .ds_cm_Commercial_retrieveRequirementsInPlanningByCommercialId(this.commercialData.id, this.bookingEditor.planningId)
        .pipe(
          take(1),
          takeUntilDestroyed(this.destroyRef),
          finalize(() => {
            this.loadingRequirements = false;
          })
        )
        .subscribe({
          next: data => {
            this.commercialData.requirements = data;
          },
          error: err => {
            this.errorService.caughtError(err);
          },
        });
    } else {
      this.api
        .ds_cm_Commercial_retrieveRequirements(this.commercialData.id)
        .pipe(
          take(1),
          takeUntilDestroyed(this.destroyRef),
          finalize(() => {
            this.loadingRequirements = false;
          })
        )
        .subscribe({
          next: data => {
            this.commercialData.requirements = data;
          },
          error: err => {
            this.errorService.caughtError(err);
          },
        });
    }
  }
}
